import _asyncToGenerator from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/root/code/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useEffect, useState } from "react";
import axios from "axios";
import loggy from "@catchoftheday/loggy";
import { theme } from "@catchoftheday/theme";
import { useSelector, useShallowSelector } from "@search-app/store";
import { ecommerceDataProducts, searchResults } from "@search-app/store/search/selectors"; // Wrapper around the dataLayer object for google analytics and related tools

export var dataLayer = {
  push: function push(data) {
    if (!window.dataLayer) {
      window.dataLayer = [];
    }

    window.dataLayer.push(data);
  }
};
/**
 * Pushes updated results into dataLayer from redux store
 */

export var useUpdateDataLayer = function useUpdateDataLayer() {
  var _useShallowSelector = useShallowSelector(function (state) {
    return {
      results: searchResults(state)
    };
  }),
      results = _useShallowSelector.results;

  var _useState = useState(null),
      customerId = _useState[0],
      setCustomerId = _useState[1];

  useEffect(function () {
    function effect() {
      return _effect.apply(this, arguments);
    }

    function _effect() {
      _effect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res, _res$data, customerId, dataLayerEntries;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return axios.get("/analytics/datalayer");

              case 2:
                res = _context.sent;
                _res$data = res.data, customerId = _res$data.customerId, dataLayerEntries = _res$data.dataLayer;
                dataLayerEntries === null || dataLayerEntries === void 0 ? void 0 : dataLayerEntries.forEach(function (item) {
                  return dataLayer.push(item);
                });
                setCustomerId(customerId);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _effect.apply(this, arguments);
    }

    effect();
  }, []);
  useEffect(function () {
    function effect() {
      return _effect2.apply(this, arguments);
    }

    function _effect2() {
      _effect2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                try {
                  if (results.length > 0) {
                    updateProductDataLayerEntry({
                      siteType: window.matchMedia("(max-width: ".concat(theme.breakpoints.md, ")")).matches ? "m" : "d",
                      customerId: customerId,
                      productIds: results.slice(0, 5).map(function (result) {
                        return result.id;
                      }),
                      products: results.slice(0, 5).map(function (result) {
                        return {
                          id: result.id,
                          isAdult: result.adult === true ? "1" : "0"
                        };
                      })
                    });
                  }
                } catch (e) {
                  loggy.error(e);
                }

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _effect2.apply(this, arguments);
    }

    effect();
  }, [customerId, results]);
};
export function updateProductDataLayerEntry(_ref) {
  var customerId = _ref.customerId,
      productIds = _ref.productIds,
      siteType = _ref.siteType,
      products = _ref.products;
  dataLayer.push({
    ecomm_pagetype: "searchresults",
    CustomerID: customerId ? "".concat(customerId) : "",
    SiteType: siteType,
    PageType: "Search",
    ProductID: productIds,
    Products: products
  });
} // Updates window.ecommerceData.products

export function updateEcommerceData(products) {
  {
    if (true) {
      if (!window.ecommerceData) {
        window.ecommerceData = {};
      }

      window.ecommerceData.products = products;
    }
  }
}
/**
 * Updates products in ecommerceData layer with products from redux store
 */

export var useUpdateEcommerceData = function useUpdateEcommerceData() {
  var products = useSelector(function (state) {
    return ecommerceDataProducts(state);
  });
  useEffect(function () {
    updateEcommerceData(products);
  }, [products]);
};